import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VrcSidebarFooterComponent } from './vrc-sidebar-footer.component';

@NgModule({
  declarations: [VrcSidebarFooterComponent],
  exports: [VrcSidebarFooterComponent],
  imports: [
    CommonModule
  ]
})
export class VrcSidebarFooterModule { }
